import Vue from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import Vuelidate from "vuelidate";
import axiosInstance from "./services/axiosInstance";
import pusherInstance from "./services/pusherInstance";
import { auth } from "./utils/auth";

Vue.config.productionTip = false;
Vue.use(Vuelidate);

//Initialize Backend URL
const baseURL = process.env.VUE_APP_BACKEND_URL;

//Server URL for QR code
const networkURL = process.env.VUE_APP_SERVER_URL;

Vue.prototype.$axios = axiosInstance;
Vue.prototype.$url = baseURL;
Vue.prototype.$network = networkURL;
Vue.prototype.$pusher = pusherInstance;
Vue.prototype.$auth = auth;

Vuex.Store.prototype.$axios = axiosInstance;
Vuex.Store.prototype.$router = router;
Vuex.Store.prototype.$auth = auth;
Vuex.Store.prototype.$store = store;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
